// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_html2canvas_dist_html2canvas_js":"0c38a61b2a38123d","node_modules_dompurify_dist_purify_js":"fd8ac805a9d05c01","node_modules_canvg_lib_index_es_js":"41207c58e5bcca31"}[chunkId] + ".js";
};